import {createSmartAction} from 'redux-smart-actions';

export const getHomepage = createSmartAction(() => ({
  request: {
    url: 'mco-leclub-api/v1/post/leclub-connecte',
  },
}));

// Nom distinct de getGifts (api/gifts) : les deux modules sont fusionnés dans le même objet `api`.
export const getHomepageGifts = createSmartAction(() => ({
  request: {
    url: '/wp/v2/cadeaux?per_page=4',
  },
}));

export const getPost = createSmartAction(({id, type}) => ({
  request: {
    url: `/wp/v2/${type}/${id}`,
  },
  meta: {requestKey: `${type}/${id}`},
}));
